import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogsService } from 'app/dialogs/services/dialogs.service';
import {finalize} from 'rxjs/operators';

import * as moment from 'moment';

import {NavService} from 'shared/nav/nav.service';
import { DefaultPage } from '../default-page/default-page';
import { ThesesStats } from 'app/dialogs';
import { UserService } from 'app/profile';

@Component({
  selector: 'theses-page',
  templateUrl: 'theses-page.html',
  styleUrls: ['theses-page.scss'],
})
export class ThesesPage extends DefaultPage {

  public isLoading: boolean = false;

  public systemNames = ['mindset', 'efficacy', 'performance', 'mood'];

  public iName = 0;
  public date = new Date();
  public range = 'w';
  public group = 'u';

  public diaData: Array<ThesesStats> = [];

  public dateTitle = '';
  public dateText = '';
  public monShort: Array<string>;
  private monLong: Array<string>;

  public minDate;
  public maxDate = moment.utc().startOf('day').toISOString();

  constructor(
    public navService: NavService,
    private dialogsService: DialogsService,
    private translateService: TranslateService,
    private userService: UserService,
  ) {
    super(navService);
    /*if ( navService.get('start') !== undefined ) {
      const type = navService.get('start');
      for (let i = 0; i < this.systemNames.length; i++) {
        if ( this.systemNames[i] == type ) {
          this.iName = i;
        }
      }
    }*/
  }

  private ionViewWillEnter(): void {
    // this.isLoading = true;
    // this.userService.getCreated().subscribe((date) => {
    //   this.minDate = moment.utc(date).startOf('day').toISOString();
    // });
    // this.monShort = this.translateService.instant('COMMON.MONTHSHORTNAMES').split(/\s*,\s*/);
    // this.monLong = this.translateService.instant('COMMON.MONTHLONGNAMES').split(/\s*,\s*/);
    // this.load();
  }

  private load(): void {
    const mom = moment(this.date);
    if ( this.range == 'w' ) {
      this.dateTitle = this.translateService.instant('COMMON.CALENDARWEEK')+' '+ mom.isoWeek();
      this.dateText = mom.startOf('isoWeek').format('D MMM')+' - '+mom.endOf('isoWeek').format('D MMM YYYY');
    }
    else if ( this.range == 'm' ) { // month
      this.dateTitle = this.monLong[mom.month()];
      this.dateText = this.monShort[mom.month()]+' '+mom.year();
    }
    else if ( this.range == 'q' ) { // quarter
      const quarter = mom.quarter();
      this.dateTitle = this.translateService.instant('COMMON.QUARTER')+' '+ quarter;
      this.dateText = this.monShort[quarter*3-3]+' - '+this.monShort[quarter*3-1]+' ' + mom.year();
    }

    this.dialogsService.getThesesStats(this.systemNames[this.iName], this.date, this.range, 'u,c')
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((stats: Array<ThesesStats>) => {
        this.diaData = stats;
    });
  }

  public openCalendar() {

  }

  public moveName(delta: number): void {
    this.iName = (this.iName + this.systemNames.length + delta) % this.systemNames.length;
    this.update();
  }

  public update() {
    console.log(this.date);
    this.load();
  }
}
